import { FC, PropsWithChildren, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./Modal.module.scss";
import cn from "classnames";
import { useModal } from "@hooks/useModal";

interface Props {
    isVisible: boolean;
    setIsVisible(isVisible: boolean): void;
    classNames?: string;
}

const Modal: FC<PropsWithChildren & Props> = ({ children, isVisible, setIsVisible, classNames }) => {
    const ref = useRef<HTMLDialogElement>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [_, handleHide] = useModal(setIsVisible);

    useEffect(() => {
        const keyboardListener = (e: KeyboardEvent) => e.key === "Escape" && handleHide();
        document.addEventListener("keydown", keyboardListener);
        return () => {
            document.removeEventListener("keydown", keyboardListener);
        };
    }, []);

    useEffect(() => {
        if (isVisible) {
            setIsModalVisible(true);
        } else {
            setTimeout(() => {
                setIsModalVisible(false);
            }, 100);
        }
    }, [isVisible]);

    useEffect(() => {
        if (ref.current) (ref.current.querySelectorAll("input, a, button")[1] as HTMLElement)?.focus();
    }, [isModalVisible]);

    return (
        <>
            {isModalVisible &&
                createPortal(
                    <dialog
                        ref={ref}
                        onClick={handleHide}
                        className={cn(styles.modal, { [styles.visible]: isVisible }, classNames)}
                    >
                        {children}
                    </dialog>,
                    document.body,
                )}
        </>
    );
};

export default Modal;
